/**
 * Formats a distance in miles into a rounded string (e.g., "0.5").
 */
const formatNearbyDistance = (distanceMiles: number): string => {
  const rounded = Math.round(Math.max(distanceMiles, 0) * 10) / 10;
  return `${rounded}`;
};

export default formatNearbyDistance;
